export default __webpack_public_path__ + "static/media/rotating-logo.bbfa9166.gif";